import { Panel, Table } from '@/components/Bicester';
import { Cell } from '@/components/Bicester/Table';
import { DateTimeCell, ShoppingVillageCell } from '@/components/Bicester/Table/Cells';
import { BICESTER_FULL_DATE, BICESTER_FULL_DATE_HOURS_MINUTES } from '@/constants/dateFormat';
import useRouter from '@/hooks/useRouter';
import useTable from '@/hooks/useTable';
import { fetchRSVPList } from '@/services/account';
import { useRequest } from 'ahooks';
import dayjs from 'dayjs';
import React from 'react';

const RSVPRecord = () => {
  const { match, query } = useRouter<{ id: string }>();

  const {
    run: getRecordList,
    data: { content_list: recordListData, current_page, total } = {},
    loading: recordListLoading,
  } = useRequest<any>(fetchRSVPList, { manual: true });

  const { onChange } = useTable(async (p) => {
    const params = Object.assign({}, p, { member_id: match.params.id });
    await getRecordList(params);
  });

  return (
    <Panel
      title="活动RSVP记录"
      expanded
      defaultExpand={false}
      onExpand={(expanded) =>
        expanded &&
        !recordListData?.length &&
        getRecordList({ page: 1, member_id: match.params.id })
      }
      subTitle={`总计 ${total || 0} 条`}
    >
      <Table
        pageInfo={{ page: current_page, total }}
        data={recordListData ?? []}
        loading={recordListLoading}
        columns={[
          {
            columnProps: { flexGrow: 2 },
            header: '活动时间',
            cell: (
              <Cell>
                {(rowData) =>
                  `${dayjs(new Date(rowData?.start_at)).format(BICESTER_FULL_DATE)}-${dayjs(
                    new Date(rowData?.end_at)
                  ).format(BICESTER_FULL_DATE)}`
                }
              </Cell>
            ),
          },
          {
            columnProps: { flexGrow: 3 },
            header: '活动名',
            cell: <Cell dataKey="store_name" />,
          },
          {
            columnProps: { flexGrow: 1.5 },
            header: '活动购物村',
            cell: <ShoppingVillageCell dataKey="shopping_village" />,
          },
          {
            columnProps: { flexGrow: 1 },
            header: '入场人数',
            cell: <Cell dataKey="join_count" />,
          },
          {
            columnProps: { flexGrow: 2 },
            header: '入场时间',
            cell: <DateTimeCell dataKey="join_date" format={BICESTER_FULL_DATE_HOURS_MINUTES} />,
          },
        ]}
        onChange={onChange}
      >
        <Table.Body isEmptyHoverBody={false} />
        <Table.Pagination />
      </Table>
    </Panel>
  );
};

export default RSVPRecord;
